import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { Text } from '../../../../components/presentation/Text'
import { placesClient } from '../../../../utils/apollo/api'
import { useFormattedPlacesForTable } from '../_data/formatPlacesForTable'
import { useGetAllPlaces } from '../../../../containers/places/SelectAllPlacesLink'
import { useOpenPlaceModal } from '../../../../utils/routes/modals/modalsActions'
import { usePlaceType, useTypePermission } from '../../_context/PlaceTypeContext'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useSortedEnabledLevels } from '../../_data/filteredLevels'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../components/actions/Link'
import ListCounter from '../../../../components/helpers/ListCounter'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'
import { usePlaceActionsList } from '../../../../utils/actions/place/list'

const PlacesTable = () => {
  const { t } = useTranslation()
  const canEdit = useTypePermission('edit')
  const setPlace = useOpenPlaceModal()
  const data = useFormattedPlacesForTable()
  const levels = useSortedEnabledLevels()
  const type = usePlaceType()
  const onSelectAll = useGetAllPlaces(type)

  const columns = [
    ...levels.map((level, index) => ({
      label: level.name,
      headerSideContent: index === 0 && (
        <>
          <ListCounter
            client={placesClient}
            entity="places"
            filterName="PlaceFilter"
            filters={{ types: [type], includeDisabled: true }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'placeLevel' + level.id,
      sortIndex: index === 0 && 'NAME',
      flex: index === 0 ? 6 : 4,
      render: (value, record) =>
        index === 0 ? (
          <Link onClick={() => setPlace(record)}>
            <Text strong color={COLORS.dark2}>
              {record.name}
            </Text>
          </Link>
        ) : (
          <Text color={COLORS.dark3} size="small">
            {record.placeLevelsResume?.find(pl => pl.levelId === level.id)?.name}
          </Text>
        )
    })),

    {
      label: t('listPlaces:activated'),
      dataIndex: 'enabled',
      sortIndex: 'ENABLED',
      flex: 1,
      render: (_, record) => (
        <SwitchDisabled client={placesClient} entity="Place" record={record} size={'small'} disabled={!canEdit} />
      )
    },

    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(usePlaceActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" _TODO_onSelectAll={onSelectAll} />
}

export default PlacesTable
